<template>
  <div class="stk-py-6">
    <TaskIndex
      title="Snoozed Tasks"
      status="snoozed"
    />
  </div>
</template>

<script>
import TaskIndex from '@frontend/ui/features/tasks/components/tasks/TaskIndex.vue';

export default {
  name: 'ActionCenterSnoozedView',
  components: {
    TaskIndex,
  },
};
</script>
